class AuthUnauthorizedError extends Error {
  constructor() {
    super('Auth Unauthorized');
  }
}

export default AuthUnauthorizedError;
